import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RuntimeConfigService } from './runtime-config.service';
import { School } from '../app/models/school.model';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';
import { HybridStorageService } from '../app/services/hybrid-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private apiUrl: string;
  private systemPushPermissionGranted: boolean = false;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private http: HttpClient,
    private runtimeConfig: RuntimeConfigService,
    private hybridStorageService: HybridStorageService
  ) {
    this.apiUrl = this.runtimeConfig.currentConfig.apiUrl;
    // Subscribe to config changes to update apiUrl
    this.runtimeConfig.config$.subscribe(config => {
      this.apiUrl = config.apiUrl;
    });
  }

  getNewMessageCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/chat/GetNewMessageCountByUserIdAsync`);
  }

  getCurrentSchoolList(): Observable<School[]> {
    return this.http.get<School[]>(`${this.apiUrl}/school/GetCurrentSchoolsAsync`);
  }

  set setSystemPushPermissionGranted(value: boolean) {
    this.systemPushPermissionGranted = value;
  }

  get getSystemPushPermissionGranted(): boolean {
    return this.systemPushPermissionGranted;
  }

  async openAppSettings() {
    try {
      await NativeSettings.open({
        optionAndroid: AndroidSettings.ApplicationDetails,
        optionIOS: IOSSettings.App
      });
    } catch (error) {
      console.error("Failed to open system settings:", error);
    }
  }

  public async clearAll() {
    await this.hybridStorageService.clear();
  }
}

export type NotificationHeaderSummary = {
  MessageCount: number,
  PostCount: number,
  NotificationCount: number
};